module.exports = __webpack_public_path__ + "assets/img/text-qw-63953bab.png";